<template>
    <div v-if="unit.deviceLgSmart" style="margin-top: -2px; margin-right: 4px;">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <a
                    v-bind = "attrs"
                    v-on   = "on"
                    @click.prevent="onLgSmart"
                >
                    <v-icon color="primary" size="22">mdi-router-wireless</v-icon>
                </a>
            </template>
            <span>Liftguardian Smart</span>
        </v-tooltip>
    </div>
</template>

<script>
import main from "@/main";

export default {
    name: "CLgsButton",

    props: {
        unit: {

        }
    },

    methods: {
        onLgSmart () {
            let url = main.url.dashboard();
            window.open(url + this.unit.id, "_blank");
        },
    }
}

</script>

<style scoped>

</style>